import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import {
  TextBlock,
  MediaBlock,
  TextRow,
  RectShape,
  RoundShape,
} from 'react-placeholder/lib/placeholders';
import { Panel, Row, Col } from 'react-bootstrap';
import { observer, inject } from 'mobx-react';
import Loading from '../common_components/Loading';

@inject('rootStore')
export default class BmcLoading extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { rootStore } = this.props;

    if (rootStore.oneBlockMode.active) {
      return (
        <div className="react-board">
          <br />
          <br />
          <Row>
            <div
              className="col-md-8 col-md-push-2 bmc-col-lane"
              style={{ paddingBottom: '25px' }}
            >
              <TextBlock rows={10} color="#d4d4d4" />
            </div>
          </Row>
        </div>
      );
    }

    return <Loading />;
  }
}

/*

            <div className="react-board">

                <br/><br/>

                <Row>
                    <TextBlock rows={4} color='#d4d4d4'/>
                </Row>

                <br/>
                <hr/>


                <Row>
                    <div style={{textAlign: "center", paddingTop: "15px", paddingBottom: "15px"}}>
                        <TextBlock rows={1} color='#d4d4d4'/>
                    </div>
                </Row>

                <Row>
                    <div className="col-md-2-4 col-md-push-4-8  bmc-col-lane">
                        <TextBlock rows={10} color='#d4d4d4'/>
                    </div>

                    <div className="col-md-2-4 col-md-push-7-2  bmc-col-lane">
                        <TextBlock rows={10} color='#d4d4d4'/>
                    </div>


                    <div className="col-md-2-4 col-md-push-2-4 bmc-col-lane">
                        <Row>
                            <TextBlock rows={10} color='#d4d4d4'/>
                        </Row>
                    </div>


                    <div className="col-md-2-4 col-sm-pull-4-8 bmc-col-lane">
                        <Row>
                            <TextBlock rows={10} color='#d4d4d4'/>
                        </Row>
                    </div>

                    <div className="col-md-2-4 col-sm-pull-9-6  bmc-col-lane ">
                        <TextBlock rows={10} color='#d4d4d4'/>
                    </div>
                </Row>

                <Row>
                    <div className="col-sm-6 bmc-col-lane bmc-col-lane">
                        <TextBlock rows={4} color='#d4d4d4'/>
                    </div>
                    <div className="col-sm-6 bmc-col-lane bmc-col-lane">
                        <TextBlock rows={4} color='#d4d4d4'/>
                    </div>
                </Row>
</div>
*/
